import Service from "../../Services";

const Floor = {
  namespaced: true,
  state: {
    form: {
      is_publish: true,
      floor_id: "",
      floor_name: "",
      floor_number: "",
      branch_id: null,
      image_url: "",
      image_url_show: ""
    }
  },
  mutations: {
    GET_FORM: (state, res) => {
      state.form = res;
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        is_publish: true,
        floor_id: "",
        floor_name: "",
        floor_number: "",
        branch_id: null,
        image_url: "",
        image_url_show: ""
      };
    }
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getFloor({ commit }, {page,search,sort_branch,sort_number}) {
      return Service.FloorAPI.getFloor(page,search,sort_branch,sort_number);
    },
    // eslint-disable-next-line no-unused-vars
    showFloor({ commit }, id) {
      return Service.FloorAPI.showFloor(id);
    },
    // eslint-disable-next-line no-unused-vars
    saveFloor({ commit }, { id, data }) {
      if (id) {
        return Service.FloorAPI.updateFloor(id, data);
      } else {
        return Service.FloorAPI.createFloor(data);
      }
    },
    // eslint-disable-next-line no-unused-vars
    deleteFloor({ commit }, id) {
      return Service.FloorAPI.deleteFloor(id);
    },
    getFloorAll() {
      return Service.FloorAPI.getFloorAll();
    },
    setFormFloor({ commit }, res) {
      commit("GET_FORM", res);
    },
    clearFormData({ commit }) {
      commit("CLEAR_FORM_DATA");
    }
  }
};
export default Floor;
